// Utils
import { convertChartLayout } from "./converter.chart.layout";

// Converters
import { convertAverageData } from "./converter.chart.averages";
import { convertIndividualsData } from "./converter.chart.individuals";

// Types
import { LD12Chart } from "store/slice/charts";
import { BehaviouralComparisonResponse } from "services";
import { mergeSeriesIntoLD12Series } from "utils";

export type TBCSectionData = {
    id: number | string;
    label: string;
    company_name: string;
    entity_type: "person" | "company";
    entity_id: number;
    entity_name: string;
    has_real_pace: boolean;
    show_real_pace: boolean;
    series: Record<string, number | null>;
    enabled?: boolean;
    visible?: boolean;
};

export const convertPaceBehaviouralComparison = (data: BehaviouralComparisonResponse): LD12Chart => {
    // Get Axes from OVERALL
    const hubAverage = data.graphs.find((graph) => graph.id === "OVERALL");

    let hubAverageData: TBCSectionData | undefined = undefined;
    let averagesData: (TBCSectionData | undefined)[] = [];
    let individualsData: (TBCSectionData | undefined)[] = [];
    let axes = [];

    // Get OVERALL Data
    if (hubAverage) {
        axes = convertChartLayout(hubAverage);
        hubAverageData = convertAverageData(hubAverage);
    }

    // Get Other AVERAGES Data
    const averages = data.graphs.filter((graph) => graph.id.includes("AVERAGE"));
    if (averages.length) {
        averagesData = averages.map((average) => convertAverageData(average));
    }

    // Get Individuals Data
    const individuals = data.graphs.find((graph) => graph.id.includes("INDIVIDUALS"));
    if (individuals) {
        individualsData = convertIndividualsData(individuals) || [];
    }

    const allData = [hubAverageData, ...averagesData, ...individualsData];
    const series = allData.map((el) => el?.series);
    const seriesLabels = allData
        .filter((el) => el !== undefined)
        .map((el) => {
            if (el?.series) {
                const { series, ...others } = el;
                return others;
            }
            return el;
        });

    return {
        name: "Behavioral Comparison",
        axes,
        //@ts-ignore
        series_labels: seriesLabels,
        series: mergeSeriesIntoLD12Series(series),
        data_errors: [],
        leadership_insight: { insight: "", explainer: [], text: "", questions: [] },
    };
};
